import { render, staticRenderFns } from "./BoilerplateList.vue?vue&type=template&id=6d74ca66&scoped=true&lang=pug"
import script from "./BoilerplateList.vue?vue&type=script&lang=js"
export * from "./BoilerplateList.vue?vue&type=script&lang=js"
import style0 from "./BoilerplateList.vue?vue&type=style&index=0&id=6d74ca66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74ca66",
  null
  
)

export default component.exports